(ns ductile.ui.logo
  (:require [ductile.ui.routes :as routes]))

(defn logo
  ([compound-name]
   (str "/images/" (case compound-name
                     "Civitavecchia" "canada.svg"
                     "Ravenna" "asia.svg"
                     "logo.svg")))
  ([system compound-name]
   (routes/absolute-path system ["images" (case compound-name
                                            "Civitavecchia" "canada.svg"
                                            "Ravenna" "asia.svg"
                                            "logo.svg")] {})))

(defn ars-logo
  ([] "/images/logo.svg")
  ([system] (routes/absolute-path system ["images" "logo.svg"] {})))
